import { KeenSliderInstance } from 'keen-slider';
import { KeenSliderHooks } from 'keen-slider/react';
import { MutableRefObject, useMemo } from 'react';
import classNames from 'classnames';
import { DotsType } from './types';
import { getVisiblePdpDots } from './utils';
interface Props {
  instanceRef: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks> | null>;
  currentSlide: number;
  dotsType: DotsType;
}
const Dots = ({
  instanceRef,
  currentSlide,
  dotsType
}: Props) => {
  const dotsArray = useMemo(() => [...Array(instanceRef.current?.track.details.slides.length).keys()], [instanceRef]);
  const visibleDots = useMemo(() => {
    return getVisiblePdpDots(dotsType, dotsArray, currentSlide);
  }, [dotsArray, currentSlide, dotsType]);
  if (dotsArray.length <= 1) return null;
  return <div className={classNames('absolute flex -translate-x-1/2 items-center justify-center lg:pb-4', {
    'bottom-0 left-1/2 pb-2': dotsType === DotsType.HomePage,
    'right-[200px] top-0 pt-2 lg:hidden': dotsType === DotsType.PDP,
    '-bottom-4 left-1/2 lg:-bottom-6 lg:!pb-0': dotsType === DotsType.CLOSEUP
  })} data-sentry-component="Dots" data-sentry-source-file="dots.tsx">
            {visibleDots.map((idx, arrayIndex) => {
      const displayedDotsCount = visibleDots.length;
      const isFirst = arrayIndex === 0;
      const isLast = arrayIndex === displayedDotsCount - 1;
      const isActive = currentSlide === idx;
      let targetIndex = idx;
      if (dotsType === DotsType.PDP) {
        if (isFirst) {
          targetIndex = 0;
        } else if (isLast) {
          targetIndex = dotsArray.length - 1;
        }
      }
      return <span key={idx} onClick={() => {
        instanceRef.current?.moveToIdx(targetIndex);
      }} className={classNames('ml-1 cursor-pointer border-0', {
        'h-1 w-1 rounded-[1px]': !isActive,
        'h-1.5 w-4 rounded-sm': isActive
      }, dotsType === DotsType.HomePage && {
        'bg-gray-500': !isActive,
        'bg-surface-scrim-white': isActive
      }, dotsType === DotsType.PDP && {
        'bg-border-gray-medium': !isActive,
        'h-1.5 w-4 bg-surface-scrim-black': isActive,
        'h-1 w-1': !isActive && (isFirst || isLast),
        'h-1.5 w-1.5': !isActive && !isFirst && !isLast
      }, dotsType === DotsType.CLOSEUP && {
        'bg-gray-200': !isActive,
        'bg-primary-main': isActive
      })} />;
    })}
        </div>;
};
export default Dots;